<!-- market-page -->
<template>
  <div class="index-page market-page">
  <el-container class="content-box">
    <!-- 固定头部标签栏 fixedMenu -->
    <el-header height="48px">
      <fixed-menu :name="name" :showSearch="showSearch" :indexName="market_menue_name" :menuData="menuData" :showAside="showAside" :showAsideImg="showAsideImg" @changeShowAside="changeShowAside" @logout="logout" :single_page="single_page"></fixed-menu>
    </el-header>
    <!-- 内容 -->
    <el-container class="content-sub-box" v-show="!tokenOverdue">
      <!-- 固定头部标签栏 sliderMenu -->
      <div v-show="showAside && (!single_page)">
        <slider-menu :textData="marketData" v-loading="loadingSlider" @chooseId="chooseId"></slider-menu>
      </div>
      <div class="tabBox" :class="showAside ? 'slider-o' : 'slider-c'">
        <!-- 页签面包屑 -->
        <!--<el-breadcrumb separator-class="el-icon-arrow-right">-->
          <!--<el-breadcrumb-item v-for="(item, index) in crumbs" :key="index" :class="index===crumbs.length-1? 'bluetext' : ''">{{item}}</el-breadcrumb-item>-->
        <!--</el-breadcrumb>-->
        <!-- tabBox 选项卡 -->
        <tab-box @openFullScreen="openFullScreen" :showArray="showArray" :indexIdC="indexId" @update:indexIdC="indexIdC => indexId = indexIdC" @closeIframe="closeIframe" @closeAllTabs="closeAllTabs" @closeOtherTabs="closeOtherTabs" v-if="global_menu_app_type!='1'"></tab-box>

        <!-- 报表页签 -->
        <div class="frame-box" v-loading="loadingFrame" v-show="indexId !== -1" v-if="global_menu_app_type=='1'">
          <div class="iframe-box">
            <iframe :src="path" frameborder="0"></iframe>
          </div>
        </div>
        <div class="frame-box" v-if="global_menu_app_type!='1'">
         <div class="first_page_container" v-show="indexId===0" >
           <div class="first_page" :style="{background: 'url('+first_page_img+') no-repeat 50%/cover'}"></div>
         </div>

          <!-- frame报表页签 -->
          <div class="iframe-box" v-for="item in showArray" :key="item.id" v-show="indexId===item.id">
            <iframe class="iframe-full-item" :class="{'iframe-full-item-active':indexId===item.id}" :src="getFramePath(item.path)" frameborder="0"></iframe>
          </div>
          <!--<div class="iframe-box">-->
          <!--<iframe :src="path" frameborder="0"></iframe>-->
          <!--</div>-->
        </div>
        <!-- 报表path为空处理 -->
        <div class="search-none" v-show="indexId === -1">
          <img class="search-noneImg" :src="dataNone">
          <p>开发中，先试试其他功能</p>
        </div>
      </div>
    </el-container>
    <!--过期账号提示 -->
    <div class="search-none" v-show="tokenOverdue">
      <img class="search-noneImg" :src="dataNone">
      <p>账号已过期，请重新<router-link to="/login">登录</router-link></p>
    </div>
  </el-container>
  </div>
</template>
<script type="text/ecmascript-6">
import fixedMenu from 'components/fixedMenu'
import sliderMenu from 'components/sliderMenu'
import {leftIn, leftOut, leftHoverIn, leftHoverOut, dataNone,first_page_img} from '@/utils/imgUrl'
import {getSliderMenu} from 'utils/api/index'
import {logout} from 'utils/api/login'
import {getCookie, dealMenuData, dealMarketData, getTheToken} from 'utils/util'
import dataTracking from 'utils/dataTracking'
import Cookies from 'js-cookie'
import tabBox from 'components/tabBox'

import {  market_marketMid, market_jumpToLogin } from "../env_config.js"
let hash = {}
export default {
  data () {
      return {
      global_menu_app_type:"",
      showArray:[],
      //单页应用
      single_page:false,
      market_menue_name:"应用市场",

      tokenOverdue: false,
      showAside: true,
      showAsideImg: leftOut,
      dataNone,
      menuData: [],
      loadingSlider: false,
      loadingFrame: false,
      indexId: 0,
      contentData: [],
      marketData: [],
      showSearch: false,
      crumbs: ['应用市场'],
      // 生产环境
      // marketMid: 1085634561,
      // jumpToLogin: 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/login',
      // 测试环境
      marketMid: market_marketMid, // 测试环境 应用市场mid
      jumpToLogin: market_jumpToLogin,
      path: '',
      name: '',
      first_page_img
    }
  },
  methods: {
    getFramePath (path) {
      return getTheToken(path)
    },
    // 全屏展开报表 tabBox
    openFullScreen () {
      let element
      if (this.indexId === 0) {
        element = document.getElementsByClassName('index-full-item')[0]
      } else {
        element = document.getElementsByClassName('iframe-full-item-active')[0]
      }
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    // 关闭某报表 tabBox
    closeIframe (id) {
      let arr = this.showArray
      let len = arr.length - 1
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].id === id) {
          arr.splice(i, 1)
          this.showArray = arr
          hash[id] = null
          if (arr.length > 0) {
            if (i >= 1) {
              this.indexId = arr[i - 1].id
            } else {
              this.indexId = 0
            }
          } else {
            this.indexId = 0
          }
        }
      }
    },
    closeAllTabs () {
      this.showArray = []
      hash = {}
    },
    // 关闭其他报表，tabBox
    closeOtherTabs (id) {
      let arr = this.showArray
      let res = []
      hash = {}
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          res.push(arr[i])
          hash[id] = 1
        }
      }
      this.showArray = res
    },


    changeShowAside (isShow, event) {
      this.showAside = isShow
      this.showAsideImg = (event === 'click') || (event === 'outHover') ? (isShow ? leftOut : leftIn) : (isShow ? leftHoverOut : leftHoverIn)
    },
    chooseId (mid, path, name, pid) {
      // 改递归
      for (let i2 of this.marketData) {
        if (mid === i2.mid) {
          if (i2.has_child) {
            return
          } else {
            this.getPath(i2)
            this.crumbs = ['应用市场']
            this.crumbs.push(i2.menu_name)
          }
        } else {
          if (i2.has_child) {
            for (let i3 of i2.children) {
              if (mid === i3.mid) {
                if (i3.has_child) {
                  return
                } else {
                  this.getPath(i3)
                  this.crumbs = ['应用市场']
                  this.crumbs.push(i2.menu_name)
                  this.crumbs.push(i3.menu_name)
                }
              } else {
                if (i3.has_child) {
                  for (let i4 of i3.children) {
                    if (mid === i4.mid) {
                      if (i4.has_child) {
                        return
                      } else {
                        this.getPath(i4)
                        this.crumbs = ['应用市场']
                        this.crumbs.push(i2.menu_name)
                        this.crumbs.push(i3.menu_name)
                        this.crumbs.push(i4.menu_name)
                      }
                    } else {
                      if (i4.has_child) {
                        for (let i5 of i4.children) {
                          if (mid === i5.mid) {
                            if (i5.has_child) {
                              return
                            } else {
                              this.getPath(i5)
                              this.crumbs = ['应用市场']
                              this.crumbs.push(i2.menu_name)
                              this.crumbs.push(i3.menu_name)
                              this.crumbs.push(i4.menu_name)
                              this.crumbs.push(i5.menu_name)
                            }
                          } else {
                            if (i5.has_child) {
                              console.log(i5)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      console.log(this.indexId);
      if (path !== null && path !== '' && path !== undefined) {
        this.indexId = mid
        let tmp = {
          id: mid,
          path,
          name
        }
        for (let i of this.showArray) {
          if (!hash[i.id]) {
            hash[i.id] = 1
          }
        }
        if (!hash[mid]) {
          this.showArray.push(tmp)
        }
        // 设置埋点
        dataTracking('btn', {
          'userid': getCookie('dopm_user_name'),
          'time': Date(),
          'url': path,
          'menuid': mid,
          'menucode': ''
        })
      }
    },
    // 选择具体报表展示，sliderMenu/indexList ，hash去重
    // 退出登录，fixedMenu-api
    logout () {
      const _this = this
      this.$confirm('确定要注销账户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().then(res => {
          window.location.href = _this.jumpToLogin
          Cookies.remove('name')
          Cookies.remove('dopm_user_name')
          Cookies.remove('dopm_user_password')
          Cookies.remove('token')
        }).catch(() => {
          window.location.href = _this.jumpToLogin
        })
      })
    },
    getPath (item) {
      if (item.menu_path !== null && item.menu_path !== '' && item.menu_path !== undefined) {
        this.path = getTheToken(item.menu_path)
        this.indexId = item.mid
        // 设置埋点
        dataTracking('btn', {
          'userid': getCookie('dopm_user_name'),
          'time': Date(),
          'url': item.menu_path,
          'menuid': item.mid,
          'menucode': ''
        })
      } else {
        this.indexId = -1
      }
    },
    hasChild (item) {
      return item.has_child !== undefined && item.has_child === 'Y'
    }
  },
  created () {
    console.log("market.........");
    let query = location.hash
    let choose1Id = query.split('id=')[1]
    let parmas = {
      token: getCookie('token'),
      method: 'm006_4',
      userId: getCookie('dopm_user_name')
    }
    this.loadingSlider = true
    this.loadingFrame = true
    this.name = Cookies.get('name')
    // 渲染market侧边栏菜单，api, 可优化为递归处理/链表记录状态
    getSliderMenu(parmas).then(res => {
      if (res.respCode === '100') {
        if (res.respData) {
          let menu_app_type ;
          let menu_name;
          let menu_path;

          this.marketData = dealMenuData(res.respData, 'slider', this.marketMid)


          //begin-------2019_09_20 过滤掉非被打开应用的菜单
          let new_marketData = [];
          for(let index in this.marketData)
          {
            let item = this.marketData[index];

            if((item.mid+"") == choose1Id)
            {

              menu_app_type = item.menu_app_type;

              this.market_menue_name = item.menu_name;
              menu_path = item.menu_path;

              if(item.children.length>0)
              {
                for(let index in item.children)
                {
                  let sub_item = item.children[index];
                  new_marketData.push(sub_item);
                }

              }
              else
              {
                new_marketData.push(item);
              }



              break;
            }
          }
          this.marketData = new_marketData;
          console.log(this.marketData);

          //end-------2019_09_20 过滤掉非被打开应用的菜单

          this.crumbs = ['应用市场']



          //menu_app_type
          // 根据菜单类型 用不同的模式展示
          // 0默认，1单页应用，2菜单应用，3系统应用

          this.global_menu_app_type = menu_app_type;
          if("0" == menu_app_type)
          {
          }
          else if("1" == menu_app_type)
          {
            this.single_page = true;
            this.showAside = false;

          }
          else if("2" == menu_app_type)
          {

          }
          else if("3" == menu_app_type)
          {

            window.open(menu_path,'_self');
          }
          else;


          for (let item2 of this.marketData) {
            // 筛选（最高2级）
            if (item2.mid + '' === choose1Id) {
              this.indexId = item2.mid
              if (this.hasChild(item2)) {
                // 3级
                let item3 = item2.children[0]
                this.crumbs.push(item2.menu_name)
                if (this.hasChild(item3)) {
                  // 4级
                  let item4 = item3.children[0]
                  this.crumbs.push(item3.menu_name)
                  if (this.hasChild(item4)) {
                    let item5 = item4.children[0]
                    this.crumbs.push(item5.menu_name)
                    this.getPath(item5)
                  } else {
                    this.crumbs.push(item4.menu_name)
                    this.getPath(item4)
                  }
                } else {
                  this.crumbs.push(item3.menu_name)
                  this.getPath(item3)
                }
              } else {
                this.crumbs.push(item2.menu_name)
                this.getPath(item2)
              }
            }
          }
          this.loadingFrame = false
          this.loadingSlider = false




        } else {
          this.tokenOverdue = true
        }


      }
    }).catch(() => {
      this.loadingFrame = false
      this.loadingSlider = false
    })
  },
  components: {
    fixedMenu,
    sliderMenu,
    tabBox
  }
}
</script>
<style lang="less">
@import '~assets/style/variable.less';
@import '~assets/style/mixin.less';

.first_page_container
{
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
}
.first_page
{
  display: inline-block;
  height: 60%;
  width: 100%;
  background-size: auto 100%;
}

.index-page {
  height: 100%;
}
.market-page {
  .search-none {
    height: 346px !important;
  }
}
.content-sub-box {
  color: #333;
  position: relative;
}
.tabBox {
  box-shadow: 4px 4px 8px 8px rgba(204,204,204,0.5);
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 0;
  top: 8px;
}
.slider-o {
  left: 208px;
}
.slider-c {
  left: 8px;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 48px;
  padding: 0;
}
.content-box {
  height: 100%;
}
body > .el-container {
  margin-bottom: 40px;
  padding: 8px;
}
.el-breadcrumb {
  height: 36px;
  line-height: 36px !important;
  padding: 0 10px;
}
.bluetext {
  .el-breadcrumb__inner {
    color: @color-theme !important;
  }
}
.frame-box {
  background: #fff;
  position: absolute;
  bottom: 0;
  top: 36px;
  left: 0;
  right: 0;
}
.iframe-box {
  width: 100%;
  height: 100%;
  padding: 8px 0 0 0;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/market.vue